var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlManage24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Manage24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: -8,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconManage",
    transform: "translate(3.000000, 3.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1707057,4 L0,4 L0,2 L12.1707057,2 C12.5825421,0.834807627 13.6937812,0 15,0 C16.6568542,0 18,1.34314575 18,3 C18,4.65685425 16.6568542,6 15,6 C13.6937812,6 12.5825421,5.16519237 12.1707057,4 Z M5.82929429,8 L18,8 L18,10 L5.82929429,10 C5.41745788,11.1651924 4.30621883,12 3,12 C1.34314575,12 0,10.6568542 0,9 C0,7.34314575 1.34314575,6 3,6 C4.30621883,6 5.41745788,6.83480763 5.82929429,8 Z M7.17070571,14 C7.58254212,12.8348076 8.69378117,12 10,12 C11.3062188,12 12.4174579,12.8348076 12.8292943,14 L18,14 L18,16 L12.8292943,16 C12.4174579,17.1651924 11.3062188,18 10,18 C8.69378117,18 7.58254212,17.1651924 7.17070571,16 L0,16 L0,14 L7.17070571,14 Z M10,16 C10.5522847,16 11,15.5522847 11,15 C11,14.4477153 10.5522847,14 10,14 C9.44771525,14 9,14.4477153 9,15 C9,15.5522847 9.44771525,16 10,16 Z M3,10 C3.55228475,10 4,9.55228475 4,9 C4,8.44771525 3.55228475,8 3,8 C2.44771525,8 2,8.44771525 2,9 C2,9.55228475 2.44771525,10 3,10 Z M15,4 C15.5522847,4 16,3.55228475 16,3 C16,2.44771525 15.5522847,2 15,2 C14.4477153,2 14,2.44771525 14,3 C14,3.55228475 14.4477153,4 15,4 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlManage24);
export default __webpack_public_path__ + "static/media/controlManage24.4719848d8065761eccd7c252b7cc24fc.svg";
export { ForwardRef as ReactComponent };